import { render, staticRenderFns } from "./ComplaintsForms.vue?vue&type=template&id=78fc3a59&scoped=true&lang=pug&"
import script from "./ComplaintsForms.vue?vue&type=script&lang=ts&"
export * from "./ComplaintsForms.vue?vue&type=script&lang=ts&"
import style0 from "./ComplaintsForms.vue?vue&type=style&index=0&id=78fc3a59&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78fc3a59",
  null
  
)

export default component.exports